import BarChart from "../../../../components/charts/BarChart";
import {
    barChartDataDailyTraffic,
    barChartDataDevicesPerProduct, barChartDataFwVersionsPerProduct, barChartDataSchedulesPerProduct,
    barChartOptionsDailyTraffic,
    barChartOptionsDevicesPerProduct, barChartOptionsFirmwareVersions
} from "../../../../variables/charts";
import Card from "../../../../components/card";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";

const FirmwareDeviceAnalytics = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [pId, setProductId] = useState("")

    let [dataCount, setDataCount] = useState([]);
    let [productCatalog, setProductCatalog] = useState([])
    let [refreshData, setRefreshData] = useState(true)
    let [options, setOptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState("")
    let [isLoading, setIsLoading] = useState(true)
    let [productName, setProductName] = useState("Immensa UCP 9W")

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getFirmwareAnalyticsForProduct(productId) {
        setIsLoading(true)
        //console.log("ProductId", productId)
        if ((accesscontrollevel.toString() === "1") || accesscontrollevel.toString() === "2" || (accesscontrollevel.toString() === "5")) {
            const chartLabels = [];
            const count = [];
            setProductId(productId)
            pId = productId
            if(productId === null || productId === undefined || productId === ""){
                productId = "jakophb6lnzbpgpd"
                setProductId("jakophb6lnzbpgpd")
            }
            const url = CROMPTON_ANALYTICS_URL + "v1/device/version/statistics/" + productId;

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                for (let i = 0; i < res.data.swVersions.length; i++) {
                    if(res.data.swVersions[i].count !== 0) {
                        chartLabels.push(res.data.swVersions[i].name.replace("V", ""));
                        count.push(res.data.swVersions[i].count);
                    }
                }

                //console.log(count)
                setDataCount(JSON.parse(JSON.stringify(count)))
                dataCount = JSON.stringify(count)
                //console.log(chartLabels)

                setOptions(chartLabels)
                options = chartLabels

                /*localStorage.setItem("productName", JSON.stringify(chartLabels))
                localStorage.setItem("fwVersions", JSON.stringify(count))*/

                setIsLoading(false)

                setProductCatalog(JSON.parse(sessionStorage.getItem("productCatalogArray")))
                productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"))
                setRefreshData(false)
                //console.log(productCatalog)

                //getPlWiseDistributionTrend()
                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                setRefreshData(true)
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    useEffect(() => {
        //console.log("Refresh")
        //console.log(sessionStorage.getItem("productId"))
        if(sessionStorage.getItem("productId") !== null && sessionStorage.getItem("productId") !== ""){
            setProductName(sessionStorage.getItem("productName"))
            getFirmwareAnalyticsForProduct(sessionStorage.getItem("productId"))
        }else{
            getFirmwareAnalyticsForProduct("")
        }


    }, [pId])

    function handleChangeProductDropDown(event) {
        const selectBox = document.getElementById("productFirmwareDropDown")
        pId = selectBox.options[selectBox.selectedIndex].value
        setProductId(selectBox.options[selectBox.selectedIndex].value)
        sessionStorage.setItem("productId", pId)
        setProductName(event.target.option);
        sessionStorage.setItem('productName', event.target.option);
        getFirmwareAnalyticsForProduct(pId)
    }


    return (
        <Card extra="w-full h-full  pb-7 p-[20px]">
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Firmware Analytics
                </h2>
                <div className="mb-6 flex items-center justify-center">
                    <select id="productFirmwareDropDown" onChange = {handleChangeProductDropDown}  key={productName} value={pId}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        {
                            productCatalog.map((Val) => {
                                    return (
                                        <option value={Val.productId} key={Val.product}>{Val.product}</option>
                                    )
                                }
                            )
                        }
                        {/*<option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>*/}
                    </select>
                </div>
            </div>

            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-red-700 dark:text-white">
                    {errorMessage}
                </h2>
            </div>

            <div className="h-[300px] w-full pt-10 pb-0">
                {!isLoading &&
                <BarChart
                    chartData={[
                        {
                            name: "Devices",
                            data: dataCount
                        }
                    ]}
                    chartOptions={{
                        chart: {
                            toolbar: {
                                show: true,
                            },
                        },
                        tooltip: {
                            style: {
                                fontSize: "12px",
                                fontFamily: undefined,
                                backgroundColor: "#000000"
                            },
                            onDatasetHover: {
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                },
                            },
                            theme: "dark",
                        },
                        xaxis: {
                            categories: options,
                            show: true,
                            labels: {
                                show: true,
                                style: {
                                    colors: "#A3AED0",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                },
                            },
                            axisBorder: {
                                show: false,
                            },
                            axisTicks: {
                                show: false,
                            },
                        },
                        yaxis: {
                            show: true,
                            color: "black",
                            labels: {
                                show: true,
                                style: {
                                    colors: "#CBD5E0",
                                    fontSize: "14px",
                                },
                            },
                        },
                        grid: {
                            show: false,
                            strokeDashArray: 5,
                            yaxis: {
                                lines: {
                                    show: true,
                                },
                            },
                            xaxis: {
                                lines: {
                                    show: true,
                                },
                            },
                        },
                        fill: {
                            type: "gradient",
                            gradient: {
                                type: "vertical",
                                shadeIntensity: 1,
                                opacityFrom: 0.7,
                                opacityTo: 0.9,
                                colorStops: [
                                    [
                                        {
                                            offset: 0,
                                            color: "#0b83b5",
                                            opacity: 1,
                                        },
                                        {
                                            offset: 100,
                                            color: "#0b83b5",
                                            opacity: 0.28,
                                        },
                                    ],
                                ],
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        plotOptions: {
                            bar: {
                                borderRadius: 10,
                                columnWidth: "40px",
                            },
                        },
                    }}
                />
                }
            </div>
        </Card>
    );
};

export default FirmwareDeviceAnalytics;
